import 'css-chunksrc/client/scenes/projectCreationFromModel/modelSelection/styles.scss';export default {
  "projectModel": "_projectModel_a32iq_1",
  "header": "_header_a32iq_11",
  "title": "_title_a32iq_19",
  "main": "_main_a32iq_26",
  "subTitle": "_subTitle_a32iq_37",
  "description": "_description_a32iq_43",
  "list": "_list_a32iq_49",
  "warning": "_warning_a32iq_53",
  "loader": "_loader_a32iq_59",
  "loaderMain": "_loaderMain_a32iq_74",
  "removeIconBox": "_removeIconBox_a32iq_81",
  "removeIcon": "_removeIcon_a32iq_81",
  "buttons": "_buttons_a32iq_91",
  "cancelButton": "_cancelButton_a32iq_106",
  "submitButton": "_submitButton_a32iq_117"
};